import React from "react";
import { useSelector } from "react-redux";
import CoursesIncludedWithHigherSubscription from "./CoursesIncludedWithHigherSubscription";
import CoursesIncludedWithSubscription from "./CourseIncludedWithSubscription";
import LpIncludedWithSubscription from "./LpIncludedWithSubscription";

const LpWithSubscription = () => {
  const subscribedInfo = useSelector((state) => state.checkout.subscribedData);
  console.log("si--", subscribedInfo);

  return (
    <>
      {subscribedInfo?.status === "success" ? (
        <LpIncludedWithSubscription
          currentSubscription={subscribedInfo?.payload?.data?.subscription_name}
        />
      ) : (
        <LpIncludedWithSubscription />
      )}
    </>
  );
};

export default LpWithSubscription;
